import script from "./CreateUpdateSpecialUserGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateSpecialUserGroups.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateSpecialUserGroups.vue?vue&type=style&index=0&id=1dac1b6f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dac1b6f"]])

export default __exports__